import { Input } from '@/components/ui/input'
import { m } from '@/lib/paraglide/messages'

export interface CarrierManualUnitsInput {
    provinceId: string
    wardId: string
}

interface Props {
    value: CarrierManualUnitsInput
    onChange: (value: CarrierManualUnitsInput) => void
}

export function CarrierManualUnitsFields({ value, onChange }: Props) {
    return (
        <div className="border-warning/40 bg-warning/5 space-y-2 rounded-md border p-3">
            <p className="text-sm font-medium">{m.carrier_manual_title()}</p>
            <p className="text-muted-foreground text-xs">
                {m.carrier_manual_hint()}
            </p>
            <div className="grid grid-cols-2 gap-2">
                <div className="space-y-1">
                    <label
                        className="text-xs font-medium"
                        htmlFor="carrier-manual-province"
                    >
                        {m.carrier_manual_province()}
                    </label>
                    <Input
                        id="carrier-manual-province"
                        type="number"
                        value={value.provinceId}
                        onChange={(event) =>
                            onChange({
                                ...value,
                                provinceId: event.target.value,
                            })
                        }
                    />
                </div>
                <div className="space-y-1">
                    <label
                        className="text-xs font-medium"
                        htmlFor="carrier-manual-ward"
                    >
                        {m.carrier_manual_ward()}
                    </label>
                    <Input
                        id="carrier-manual-ward"
                        type="number"
                        value={value.wardId}
                        onChange={(event) =>
                            onChange({ ...value, wardId: event.target.value })
                        }
                    />
                </div>
            </div>
        </div>
    )
}
